import React from 'react'
import { Stack } from '@mui/material'
import Button from '@mui/material/Button'
import { useFormContext } from 'react-hook-form'

import EmailField from '@/Components/Common/Inputs/EmailField'
import TextField from '@/Components/Common/Inputs/TextField'
import PasswordFormFields from '@/Components/Pages/Accounts/PasswordFormFields'

const FormFields: React.FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext()
  return (
    <Stack gap={1}>
      <TextField {...register('first_name')} label="First Name" />
      <TextField label="Last Name" {...register('last_name')} />
      <EmailField register={register} errors={errors} disabled />
      <PasswordFormFields />
      <Button type="submit" variant="contained" color="success" sx={{ mt: 2 }}>
        Activate Account
      </Button>
    </Stack>
  )
}

export default FormFields
